/**
 * Rückweg nach der Google-Anmeldung: Wer sich auf einem Feedback-Link
 * anmeldet, soll danach wieder dort landen — nicht auf der Startseite.
 * Erlaubt sind nur Pfade unter /feedback/ (kein fremder Ort, kein „//“).
 */
const SCHLUESSEL = 'mail.nachAnmeldung';
const PRAEFIX = '/feedback/';

/** Kennzeichen am Rückweg, wenn die Anmeldung nicht geklappt hat (?anmeldung=…). */
export const ANMELDE_HINWEIS_PARAM = 'anmeldung';
export type AnmeldeHinweis = 'fehlgeschlagen' | 'abgebrochen';

export function rueckwegGueltig(pfad: unknown): pfad is string {
  return typeof pfad === 'string'
    && pfad.startsWith(PRAEFIX)
    && !pfad.includes('//')
    && !pfad.includes('\\')
    && pfad.length <= 400;
}

/** Pfad ohne ein altes Kennzeichen ?anmeldung=… (sonst hängt es nach dem nächsten Versuch noch dran). */
function ohneHinweis(pfad: string): string {
  const [weg, suche = ''] = pfad.split('?', 2);
  const params = new URLSearchParams(suche);
  params.delete(ANMELDE_HINWEIS_PARAM);
  const rest = params.toString();
  return rest ? `${weg}?${rest}` : weg;
}

/** Vor signInWithGoogle: aktuellen Feedback-Pfad merken. */
export function rueckwegMerken(pfad: string): void {
  if (!rueckwegGueltig(pfad)) return;
  try { sessionStorage.setItem(SCHLUESSEL, ohneHinweis(pfad)); } catch { /* ohne Speicher landet man auf der Startseite */ }
}

/**
 * Gemerkten Rückweg verwerfen: bei der normalen Anmeldung über /login und
 * wenn der Sprung zu Google gar nicht erst klappt — sonst landete eine
 * spätere Anmeldung im selben Tab auf einem alten Feedback-Link.
 */
export function rueckwegVergessen(): void {
  try { sessionStorage.removeItem(SCHLUESSEL); } catch { /* kein Speicher */ }
}

/** Nach der Anmeldung: gemerkten Pfad holen und löschen; sonst „/“. */
export function rueckwegHolen(): string {
  let pfad: string | null = null;
  try {
    pfad = sessionStorage.getItem(SCHLUESSEL);
    sessionStorage.removeItem(SCHLUESSEL);
  } catch { /* kein Speicher */ }
  return rueckwegGueltig(pfad) ? pfad : '/';
}

/** Feedback-Pfad mit Kennzeichen, dass die Anmeldung nicht geklappt hat. */
export function mitAnmeldeHinweis(pfad: string, hinweis: AnmeldeHinweis): string {
  const sauber = ohneHinweis(pfad);
  return `${sauber}${sauber.includes('?') ? '&' : '?'}${ANMELDE_HINWEIS_PARAM}=${hinweis}`;
}

/** Kennzeichen aus der Adresszeile lesen (nur bekannte Werte). */
export function anmeldeHinweisLesen(suche: string): AnmeldeHinweis | null {
  const wert = new URLSearchParams(suche).get(ANMELDE_HINWEIS_PARAM);
  return wert === 'fehlgeschlagen' || wert === 'abgebrochen' ? wert : null;
}
